import React from 'react';
import { RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, Radar, Legend, ResponsiveContainer, Tooltip } from 'recharts';

/**
 * Radar chart showing domain accuracy across flashcards and exams.
 */
export default function DomainRadarChart({ domainAccuracy }) {
  const data = Object.entries(domainAccuracy).map(([id, acc]) => ({
    domain: acc.shortName,
    flashcards: acc.flashcardAcc,
    exams: acc.examAcc,
    combined: acc.combined,
  }));

  if (data.every(d => d.combined === 0)) {
    return <EmptyChart message="Complete some study sessions to see your domain radar." />;
  }

  return (
    <div className="bg-gray-800/50 border border-gray-700/50 rounded-xl p-6">
      <h3 className="text-sm font-medium text-gray-400 uppercase tracking-wider mb-4">Domain Accuracy</h3>
      <ResponsiveContainer width="100%" height={300}>
        <RadarChart data={data}>
          <PolarGrid stroke="#374151" />
          <PolarAngleAxis dataKey="domain" tick={{ fill: '#9CA3AF', fontSize: 12 }} />
          <PolarRadiusAxis angle={30} domain={[0, 100]} tick={{ fill: '#6B7280', fontSize: 10 }} />
          <Radar name="Flashcards" dataKey="flashcards" stroke="#4A90D9" fill="#4A90D9" fillOpacity={0.2} />
          <Radar name="Exams" dataKey="exams" stroke="#E74C3C" fill="#E74C3C" fillOpacity={0.2} />
          <Legend wrapperStyle={{ color: '#9CA3AF', fontSize: 12 }} />
          <Tooltip contentStyle={{ backgroundColor: '#1a1a2e', border: '1px solid #374151', borderRadius: 8 }} />
        </RadarChart>
      </ResponsiveContainer>
    </div>
  );
}

function EmptyChart({ message }) {
  return (
    <div className="bg-gray-800/50 border border-gray-700/50 rounded-xl p-6">
      <h3 className="text-sm font-medium text-gray-400 uppercase tracking-wider mb-4">Domain Accuracy</h3>
      <div className="flex items-center justify-center h-48 text-gray-500 text-sm">{message}</div>
    </div>
  );
}
